<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物资名称：</span>
        </div>
          <el-select v-model="managerCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择物资名称">
          <el-option v-for="item in managerList" :key="item.code"
                     :label="item.managerText" :value="item.code">
          </el-option>
        </el-select>           
      </div>         
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">物资编号：</span>
        </div>
        <el-input v-model="formData.manageCode" size="small" style="width: 280px" disabled/>
      </div>      
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">规格型号：</span>
        </div>
        <el-input v-model="formData.specification" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">计量单位：</span>
        </div>
        <el-input v-model="formData.measureUnit" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物资类目：</span>
        </div>
        <el-select v-model="formData.categoryCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择物资类目名称">
          <el-option v-for="item in categoryList" :key="item.code"
                     :label="item.categoryName" :value="item.code">
          </el-option>
        </el-select>              
      </div>       
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">数量：</span>
        </div>
        <el-input v-model="formData.storeNumber" size="small" style="width: 280px" />
      </div>  
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">维保日期：</span>
        </div>
        <el-date-picker v-model="formData.maintenanceDate" value-format="yyyy-MM-dd" placeholder="维保时间" size="small" style="width: 280px"></el-date-picker>
      </div>  
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" type="textarea" size="small" style="width: 280px" />
      </div>                                       
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>        
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Material";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "warehousing-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "入库管理"
        }
      ],
      mainTitle: "添加物资",
      subheading: "",
      formData: {
        materialsName: "",
        categoryCode: "",
        materialsNumber: "",
        brand: "",
        storeNumber: "",
        maintenanceDate: "",
        memo: ""
      },
      categoryList: [],
      managerList: [],
      managerCodes: ""
    };
  },
  created() {
    this.remoteMethod();
    this.remoteMethod2();
  },
  methods: {
    remoteMethod(query) {
      this.getCategoryList(query);
    },
    remoteMethod2(query) {
      this.getManagerList(query);
    },
    getManagerList(searchKey) {
      this.$axios
        .post(api.getManagerList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              if (!v.specification) {
                v.specification = "无";
              }
              v.managerText = v.materialsName + " / " + v.specification;
            });
            this.managerList = list;
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getCategoryList(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            this.categoryList = list;
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    confirm() {
      if (!this.formData.manageCode) {
        nError("请输入物资名称");
        return false;
      }
      if (!this.formData.categoryCode) {
        nError("请选择物资类目");
        return false;
      }
      if (!this.formData.storeNumber) {
        nError("请输入数量");
        return false;
      }
      this.$axios
        .post(api.addStore, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "warehousing-management"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "warehousing-management"
      });
    }
  },
  watch: {
    managerCodes(val) {
      console.log(val);
      this.managerList.map(v => {
        if (v.code == val) {
          this.formData.manageCode = v.code;
          this.formData.specification = v.specification;
          this.formData.measureUnit = v.measureUnit;
          this.formData.materialsName = v.materialsName;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/WarehousingManagement/WarehousingManagementAdd.vue